import { apiService } from "@/services/api";
import { createCrudStore } from "@/store/crudStore";

const despachosStore = createCrudStore("despachos");

export default {
  ...despachosStore,
  actions: {
    ...despachosStore.actions,
    getDespachos: despachosStore.actions.getAllStates,
    postDespacho: despachosStore.actions.create,
    patchDespacho: despachosStore.actions.update,
    deleteDespacho: despachosStore.actions.delete,

    async postInformeExcel({ dispatch }, { despachoId, file }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.uploadFile("despachos", despachoId, file);
        },

        onSuccessCallback: (commit, updatedDespachoData) => {
          // Actualizar solo el despacho modificado en el estado
          // updatedDespachoData contiene el despacho completo con el informe actualizado
          commit("updateItem", updatedDespachoData);
        },
        errorMessage: "Error al cargar el archivo Excel del informe",
      });
    },

    /**
     * Crear informe para un despacho que no tiene informe
     * POST /despachos/{despachoId}/informe
     */
    async postInforme({ dispatch, commit }, { despachoId, informeData }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.postCustom(
            `/despachos/${despachoId}/informe`,
            informeData
          );
        },
        onSuccessCallback: async (commitFn, response) => {
          // Refrescar los despachos para obtener el estado actualizado
          await dispatch("getDespachos");
        },
        errorMessage: "Error al crear el informe",
      });
    },

    /**
     * Actualizar informe existente de un despacho
     * PATCH /despachos/{despachoId}/informe
     */
    async patchInforme({ dispatch, commit }, { despachoId, informeData }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.patchCustom(
            `/despachos/${despachoId}/informe`,
            informeData
          );
        },
        onSuccessCallback: async (commitFn, response) => {
          // Refrescar los despachos para obtener el estado actualizado
          await dispatch("getDespachos");
        },
        errorMessage: "Error al actualizar el informe",
      });
    },

    /**
     * Subir documento para procesamiento OCR (remito o informe)
     * POST /{endpoint}/upload
     */
    async subirDocumentoOcr(
      { dispatch },
      { file, endpoint = "despacho-ocr", empresaId = null }
    ) {
      let formData;
      if (typeof FormData !== "undefined" && file instanceof FormData) {
        formData = file;
        if (empresaId && !formData.has("empresa_id")) {
          formData.append("empresa_id", empresaId);
        }
      } else {
        formData = new FormData();
        formData.append("file", file);
        if (empresaId) {
          formData.append("empresa_id", empresaId);
        }
      }
      const cleanEndpoint = String(endpoint).replace(/^\/+|\/+$/g, "");
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.postCustom(`/${cleanEndpoint}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        },
        errorMessage: "Error al subir el archivo para OCR",
      });
    },

    /**
     * Consultar estado del documento OCR (polling)
     * GET /{endpoint}/{ocrDocumentId}
     */
    async consultarEstadoOcr(
      { dispatch },
      { endpoint = "despacho-ocr", ocrDocumentId }
    ) {
      const cleanEndpoint = String(endpoint).replace(/^\/+|\/+$/g, "");
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.getCustom(`/${cleanEndpoint}/${ocrDocumentId}`);
        },
        errorMessage: "Error al consultar estado del OCR",
      });
    },

    /**
     * Confirmar documento OCR vinculándolo con el despacho creado
     * POST /despacho-ocr/{ocrDocId}/confirm
     */
    async confirmarOcrDoc(
      { dispatch },
      { ocrDocId, despachoId, empresaId = null }
    ) {
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          const payload = { despacho_id: despachoId };
          if (empresaId) payload.empresa_id = empresaId;
          return apiService.postCustom(
            `/despacho-ocr/${ocrDocId}/confirm`,
            payload
          );
        },
        errorMessage: "Error al confirmar el documento OCR",
      });
    },

    /**
     * Rechazar documento OCR
     * POST /despacho-ocr/{ocrDocumentId}/reject
     */
    async rechazarOcrDoc({ dispatch }, ocrDocumentId) {
      const docId =
        typeof ocrDocumentId === "object" && ocrDocumentId !== null
          ? ocrDocumentId.ocrDocumentId || ocrDocumentId.id
          : ocrDocumentId;
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.postCustom(`/despacho-ocr/${docId}/reject`);
        },
        errorMessage: "Error al rechazar el documento OCR",
      });
    },

    /**
     * Verificar si el control lechero del mes seleccionado ya fue cargado
     * GET /grilla_vaca/upload-excel/check_mes?mes={mes}
     */
    async verificarControlLecheroMes({ dispatch }, mes) {
      if (!mes) return { data: { cargado: false } };
      return dispatch("executeApiCall", {
        apiCallFunction: () => {
          return apiService.getCustom(
            `/grilla_vaca/upload-excel/check_mes?mes=${encodeURIComponent(mes)}`
          );
        },
        errorMessage: "Error verificando control lechero del mes",
      });
    },
  },
};
